import { DEFAULT_COUNTRY_CODE, getCountryName } from "../../../utils/addressData";

export const emptySupplier = () => ({
    id: "",
    version: 0,
    name: "",
    street: "",
    zip: "",
    city: "",
    country: DEFAULT_COUNTRY_CODE,
    email: "",
    phone: "",
    notes: "",
});

export const normalizeInput = (value) => (typeof value === "string" ? value.trim() : "");

export const formatSupplierSubtitle = (supplier) => {
    const parts = [];
    const addressParts = [];
    if (normalizeInput(supplier.street)) addressParts.push(normalizeInput(supplier.street));
    const cityLine = [normalizeInput(supplier.zip), normalizeInput(supplier.city)].filter(Boolean).join(" ");
    if (cityLine) addressParts.push(cityLine);
    const countryValue = normalizeInput(supplier.country);
    if (countryValue) addressParts.push(getCountryName(countryValue));
    if (addressParts.length) parts.push(addressParts.join(", "));
    if (normalizeInput(supplier.email)) parts.push(normalizeInput(supplier.email));
    if (normalizeInput(supplier.phone)) parts.push(normalizeInput(supplier.phone));
    return parts.join(" • ");
};

export const getSupplierGroupKey = (supplier) => {
    const name = normalizeInput(supplier?.name);
    if (!name) {
        return "#";
    }
    const letter = name.slice(0, 1).toUpperCase();
    return /^[A-Z\u00c4\u00d6\u00dc]$/.test(letter) ? letter : "#";
};
